<!--  -->
<template>
  <div class="">
    <div class="historychoose">
      <!-- <el-tabs :tab-position="tabPosition" type="border-card">
  <el-tab-pane label="单导联心电" class="history_tab"> -->
      <h2>请选择日期范围查询<span>{{ realName }}</span><span style="color:#4da1eb">生化分析仪</span>检测记录</h2>
      <el-form ref="form" :model="form">
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择起始日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择截止日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date2" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <el-button class="xingou-blue" type="primary" @click="querylistByTime()">确认查询</el-button>
          <el-button type="primary" plain @click="queryAll()">查询所有记录</el-button>
        </el-form-item>
      </el-form>

      <!-- 添加搜索\刷新功能 -->
      <!-- <div style="text-align: right">
        <el-button circle size="small"><i class="el-icon-search"></i></el-button>
        <el-button circle size="small"><i class="el-icon-refresh"></i></el-button>
        <el-button circle size="small"><i class="el-icon-s-grid"></i></el-button>
      </div> -->
      <!-- 表格内容 -->
      <el-table :data="tableData" height="600" :header-cell-style="tableHeaderColor" border stripe style="width: 100%"
        :cell-style="{ fontSize: '16px' }" v-loading="loadingShow" element-loading-text="数据正在加载中"
        :default-sort="{ prop: 'testTime', order: 'descending' }">
        <el-table-column type="index" align="center">
        </el-table-column>
        <el-table-column prop="testTime" label="记录时间" align="center" sortable>
        </el-table-column>
        <el-table-column prop="testtype" label="类别" align="center">
        </el-table-column>
        <!-- <el-table-column prop="conclusion" label="结论" align="center">
        </el-table-column> -->
        <el-table-column prop="read" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium" style="font-size: 16px;">查看记录
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除" align="center">
          <template slot-scope="scope">
            <!-- <el-button
            size="mini"
            type="danger"
            @click.native.prevent="handleDelete(scope.$index, tableData)">删除</el-button> -->
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="生化分析仪结果" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
        <el-table :data="ConclusionData" border height="500" max-height="500" v-loading="pictLoading"
          element-loading-background=white element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading">
          <el-table-column prop="items" label="项目名称" align="center" min-width="25%">
          </el-table-column>
          <el-table-column prop="name" label="中文名称" align="center" min-width="25%">
          </el-table-column>
          <el-table-column prop="conclusion" label="结论" align="center" min-width="25%">
          </el-table-column>
          <el-table-column prop="warning" label="结果提示" align="center" min-width="25%">
          </el-table-column>
          <el-table-column prop="reference" label="参考值" align="center" min-width="25%">
          </el-table-column>
          <el-table-column prop="unit" label="单位" align="center" min-width="25%">
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- </el-tab-pane>
  </el-tabs> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabPosition: "left",
      form: {
        date1: '',
        date2: '',
      },
      former: '2022-01-01',
      latter: '2022-08-06',
      tableData: [],
      dialogVisible: false,
      ConclusionData: [
        { items: "TP", name: "总蛋白", conclusion: "", warning: "", reference: '65-85', unit: 'g/L' },
        { items: "ALB", name: "白蛋白", conclusion: "", warning: "", reference: '40-55', unit: 'g/L' },
        { items: "GLO", name: "球蛋白", conclusion: "", warning: "", reference: '20-40', unit: 'g/L' },
        { items: "A/G", name: "白球比", conclusion: "", warning: "", reference: '1.2-2.4', unit: '' },
        { items: "TBIL", name: "总胆红素", conclusion: "", warning: "", reference: '3.4-20', unit: 'umol/L' },
        { items: "ALT", name: "谷丙转氨酶", conclusion: "", warning: "", reference: '9-50', unit: 'U/L' },
        { items: "AST", name: "谷草转氨酶", conclusion: "", warning: "", reference: '15-40', unit: 'U/L' },
        { items: "GGT", name: "谷酰转肽酶", conclusion: "", warning: "", reference: '10-60', unit: 'U/L' },
        { items: "UREA", name: "尿素", conclusion: "", warning: "", reference: '2.9-8.2', unit: 'mmol/L' },
        { items: "CRE", name: "肌酐", conclusion: "", warning: "", reference: '54-109', unit: 'umol/L' },
        { items: "GLU", name: "葡萄糖", conclusion: "", warning: "", reference: '3.9-6.1', unit: 'mmol/L' },],
      loadingShow: true,
      realName: '',
    };
  },
  computed: {
  },
  methods: {
    TimeProcess(time) {
      let y = time.getFullYear();
      let MM = time.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = time.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + MM + '-' + d
    },
    querylistByTime() {
      this.loadingShow = true
      // 截止日期为空，则设为今天
      if (!this.form.date2) {
        const today = new Date();
        this.form.date2 = today;
      }
      this.startTime = this.TimeProcess(this.form.date1)
      this.endTime = this.TimeProcess(this.form.date2)
      console.log(this.startTime)
      console.log(this.endTime)
      this.$http({
        url: this.$http.adornUrl("/personal/personalbiochemicalanalyzer/listByTime"),
        // method: "get",
        // params: this.$http.adornParams({ uid: this.uid, startTime: this.startTime, endTime: this.endTime }),
        method: 'post',
        data: this.$http.adornData({ uid: this.uid, startTime: this.startTime, endTime: this.endTime }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false
          console.log("看看数据");
          console.log(data);
          this.tableData = data.personalBiochemicalAnalyzerEntities;

        } else {
          // this.getCaptcha()
          this.$message.error(data.msg);
        }
      });
    },
    queryAll() {
      this.loadingShow = true
      this.$http({
        url: this.$http.adornUrl("/personal/personalbiochemicalanalyzer/listByUid"),
        method: "get",
        params: this.$http.adornParams({ uid: this.uid }),
        // method:'post',
        // data: this.$http.adornData({uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false
          console.log("看看数据");
          console.log(data)
          this.datalist = data.personalBiochemicalAnalyzerEntities;
          this.tableData = new Array(this.datalist.length)
          this.tableData = this.datalist.reverse()


        } else {
          // this.getCaptcha()
          this.$message.error(data.msg);
        }
      });
    },
    handleClose(done) {
      done();
    },
    handleClick(e) {
      this.dialogVisible = true
      console.log(e)
      this.ConclusionData[0].conclusion = e.tp
      this.ConclusionData[1].conclusion = e.alb
      this.ConclusionData[2].conclusion = e.glo
      this.ConclusionData[3].conclusion = e.ag
      this.ConclusionData[4].conclusion = e.tbil
      this.ConclusionData[5].conclusion = e.alt
      this.ConclusionData[6].conclusion = e.ast
      this.ConclusionData[7].conclusion = e.ggt
      this.ConclusionData[8].conclusion = e.urea
      this.ConclusionData[9].conclusion = e.cre
      this.ConclusionData[10].conclusion = e.glu

      this.ConclusionData[0].warning = e.tp > 85 ? '↑' : e.tp < 65 ? '↓' : ''
      this.ConclusionData[1].warning = e.alb > 55 ? '↑' : e.tp < 40 ? '↓' : ''
      this.ConclusionData[2].warning = e.glo > 40 ? '↑' : e.tp < 20 ? '↓' : ''
      this.ConclusionData[3].warning = e.ag > 2.4 ? '↑' : e.tp < 1.2 ? '↓' : ''
      this.ConclusionData[4].warning = e.tbil > 20 ? '↑' : e.tp < 3.4 ? '↓' : ''
      this.ConclusionData[5].warning = e.alt > 50 ? '↑' : e.tp < 9 ? '↓' : ''
      this.ConclusionData[6].warning = e.ast > 40 ? '↑' : e.tp < 15 ? '↓' : ''
      this.ConclusionData[7].warning = e.ggt > 60 ? '↑' : e.tp < 10 ? '↓' : ''
      this.ConclusionData[8].warning = e.urea > 8.2 ? '↑' : e.tp < 2.9 ? '↓' : ''
      this.ConclusionData[9].warning = e.cre > 109 ? '↑' : e.tp < 54 ? '↓' : ''
      this.ConclusionData[10].warning = e.glu > 6.1 ? '↑' : e.tp < 3.9 ? '↓' : ''
    },
    //删除功能。目前简单用假数据代替，还不涉及数据库链接
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //设置表头行的样式
    tableHeaderColor() {
      return "color:#000 ;font-size:18px;text-align:center";
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl('/personal/info/getBasicInfo'),
        method: 'get',
        params: this.$http.adornParams({ uid: this.uid })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log("看看数据")
          this.realName = data.realName
          // this.age = data.age
          // this.gender = data.gender
          // var genderMap = { 0: "女", 1: "男" }
          // this.gender = genderMap[this.gender]
        } else {
          // this.getCaptcha()
          this.$message.error(data.msg)
        }
      })
    }
  },
  created() {
    this.uid = this.$store.state.personal_module.uid
  },
  mounted() {
    this.queryAll()
    this.getinfo()

  },
};
</script>
<style scoped>
.blank {
  border-radius: 4px;
  height: 18px;
}

.form-name {
  display: inline-block;
  font-weight: bold;
  font-size: 18px;
}

.xingou-blue {
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
}

.xingou-blue:hover,
.xingou-blue:focus {
  background: #4da1eb;
  border-color: #4da1eb;
  color: #fff
}
</style>